import React, { useState } from 'react';
import FullPageLoading from '../../../../Components/Utils/FullPageLoading/FullPageLoading';
import MagicForm from '../../../../Components/Form/MagicForm';
import Text from '../../../../Components/Base/Text/Text';
import apiClient from '../../../../Services/ApiClient';
import { useHealthPlanContext } from '../../../../Services/HealthPlanContext';
import { useEffectAsync } from '../../../../helpers';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import HealthPlanPrintPdfModal from '../HealthPlanPrintPdf/HealthPlanPrintPdfModal';
import { MagicField } from '../../../../Enums/MagicField.enum';
import useHealthPlanDiagnosticImagingForm from '../../Hooks/useHealthPlanDiagnosticImagingForm';
import { updateHealthPlanUserItem } from '../../Services/healthPlan.service';

interface HealthPlanDiagnosticImagingProps {
	onSuccess?: any;
	disableSubmit?: boolean;
}

export default function HealthPlanDiagnosticImaging(
	props: HealthPlanDiagnosticImagingProps,
) {
	const { onSuccess, disableSubmit } = props;
	const [initialized, setInitialized] = useState(false);
	const { healthPlanUser, activeHealthPlanUserItem } = useHealthPlanContext();
	const [defaultData, setDefaultData] = useState({});
	const [printModalOpen, setPrintModalOpen] = useState(false);
	const { formScheme } = useHealthPlanDiagnosticImagingForm();

	useEffectAsync(async () => {
		setDefaultData(activeHealthPlanUserItem?.extra?.data ?? null);
		setInitialized(true);
	});

	const handleSave = async (values: any) => {
		if (healthPlanUser?.healthPlanId && activeHealthPlanUserItem?.id) {
			await updateHealthPlanUserItem({
				healthPlanId: healthPlanUser.healthPlanId,
				healthPlanUserId: healthPlanUser.id,
				healthPlanItemId: activeHealthPlanUserItem.id,
				data: {
					extra: {
						data: values,
					},
				},
			});
			setPrintModalOpen(true);
		}
	};

	const handleAfterPrint = async () => {
		setPrintModalOpen(false);
		onSuccess?.();
	};

	if (!initialized) {
		return <FullPageLoading />;
	}

	return (
		initialized && (
			<>
				<Text
					className='danger-text mb-4'
					tx={'diabetes.healthPlanDefaultChange'}
				/>
				<MagicForm
					formScheme={formScheme}
					defaultValues={defaultData}
					onSubmit={handleSave}
					disableSubmit={disableSubmit}
				/>
				<HealthPlanPrintPdfModal
					opened={printModalOpen}
					onClose={handleAfterPrint}
					healthPlanUser={healthPlanUser}
					healthPlanUserItem={activeHealthPlanUserItem}
				/>
			</>
		)
	);
}
